import { BaseHit } from "instantsearch.js";
import {
  AdditionalWidgetProperties,
  useConnector,
} from "react-instantsearch-core-v7";
import customInfiniteHits, {
  InfiniteHitsConnector,
  InfiniteHitsConnectorParams,
  InfiniteHitsWidgetDescription,
} from "src/utils/algolia/connectors/custom-infinite-hits";

export type UseInfiniteHitsProps<THit extends BaseHit = BaseHit> =
  InfiniteHitsConnectorParams<THit>;

export function useCustomInfiniteHits<THit extends BaseHit = BaseHit>(
  props?: UseInfiniteHitsProps<THit>,
  additionalWidgetProperties?: AdditionalWidgetProperties
): ReturnType<
  typeof useConnector<
    InfiniteHitsConnectorParams<THit>,
    InfiniteHitsWidgetDescription<THit>
  >
> {
  return useConnector<
    InfiniteHitsConnectorParams<THit>,
    InfiniteHitsWidgetDescription<THit>
  >(
    customInfiniteHits as InfiniteHitsConnector<THit>,
    props,
    additionalWidgetProperties
  );
}
